<template>
  <v-layout row align-center justify-center>
    <v-flex xs4 md4 pl-4>
      <v-switch v-model="useExistingTaxi" label=" Use Existing Taxi" color="primary"></v-switch>
    </v-flex>
    <v-flex xs8 md8>
      <v-container>
        <v-autocomplete
          :error-messages="errorForField()"
          v-model="taxi"
          :items="taxis"
          :loading="loading"
          :search-input.sync="search"
          item-text="registration_number"
          label="Taxi"
          placeholder="Search by registration or plate number"
          hide-no-data
          hide-selected
          no-filter
          return-object
          :disabled="!useExistingTaxi"
          @input="handleSelected"
        ></v-autocomplete>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "existing_taxi",
  props: {
    errors: Object
  },
  data: function() {
    return {
      useExistingTaxi: false,
      taxi: {},
      loading: false,
      taxis: [],
      search: null
    };
  },
  methods: {
    handleSelected: function() {
      this.$emit("selectedTaxi", this.taxi);
    },
    errorForField: function() {
      try {
        return this.errors["use_existing"];
      } catch (err) {
        return null;
      }
    },
    resetError: function() {
      try {
        if (this.errors["use_existing"] != "") {
          this.errors["use_existing"] = "";
        }
      } catch (err) {}
    }
  },
  watch: {
    search(query) {
      this.resetError();

      if (query == null) return;
      if (query.length <= 2) return;
      if (this.loading) return;

      this.loading = true;
      let self = this;
      let url = `${this.$store.state.apiUrl}/taxi/search?query=${query}`;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          self.taxis = res.data.taxis;
          self.loading = false;
        })
        .catch(function(err) {
          console.error(err);
          self.loading = false;
        });
    },
    useExistingTaxi() {
      if (this.useExistingTaxi == false) {
        this.taxi = {};
      }
      this.$emit("useExistingTaxiToggled", this.useExistingTaxi);
    }
  }
};
</script>